import LegalDocumentPage from './LegalDocumentPage';
import privacyPolicyPdf from '@/assets/pdf/Ekan_AvisodePrivacidadeGeoescala_RSB_19062026.pdf';

export default function PrivacyPolicyPage() {
  return (
    <LegalDocumentPage
      title="Política de Privacidade"
      fileUrl={privacyPolicyPdf}
    />
  );
}
